module.exports = __webpack_public_path__ + "static/mountainsFar-69d28da290cfb43c94273bda7a25cfb2.svg";